import * as React from 'react';
interface CurrentLocationPinControlButtonProps {
  onClick: (markerCoordinates: any) => void;
}

function CurrentLocationPinControlButton({ onClick }: CurrentLocationPinControlButtonProps) {
  return (
    <div className="control-panel relative top-[39px] left-[calc(100%-195px)] z-10 shadow-[0_0_0_2px_rgba(0,0,0,.1)] w-fit rounded">
      <button
        onClick={onClick}
        className="maplibregl-ctrl-current-location-pin h-[29px] w-fit flex justify-center items-center rounded bg-white"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className="w-6 h-6"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z"
          />
        </svg>

        <div className="ml-[8px] mr-[8px]">Torna al locale</div>
      </button>
    </div>
  );
}

export default React.memo(CurrentLocationPinControlButton);
